import { useQuery } from '@tanstack/react-query'
import { baseURL } from '@/v2/constants/requests'

const EMPTY_ARRAY = []

export const useAllowedClinics = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['AllowedClinics'],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/user/allowed_clinics.json`)
      if (!res.ok) {
        throw new Error(`Error fetching allowed clinics: ${res.statusText}`)
      }
      return res.json()
    },
  })

  return {
    clinics: data ?? EMPTY_ARRAY,
    isLoading,
    isError,
  }
}
